import type { ActionType } from "typesafe-actions";
import { getType } from "typesafe-actions";

import * as OrderHistoryActions from "./actions";
import type { IOrderHistoryDetailsState } from "./types";

const initialState: IOrderHistoryDetailsState = {
  data: null!,
  hasError: false,
  isFetching: false,
  docType: null!,
  docId: null!,
  requiresUpdate: false
};

export default function orderHistoryDetailsReducer(
  state: IOrderHistoryDetailsState = initialState,
  action: ActionType<typeof OrderHistoryActions>
): IOrderHistoryDetailsState {
  switch (action.type) {
    case getType(OrderHistoryActions.fetchOrderHistoryDocumentStart): {
      return {
        ...initialState,
        ...action.payload,
        isFetching: true
      };
    }

    case getType(OrderHistoryActions.fetchOrderHistoryFail): {
      return {
        ...state,
        hasError: true,
        isFetching: false
      };
    }

    case getType(OrderHistoryActions.fetchOrderHistoryDocumentSuccess): {
      return {
        ...state,
        data: action.payload,
        isFetching: false,
        requiresUpdate: false
      };
    }

    case getType(OrderHistoryActions.markPartialQuickBuyForUpdate): {
      return {
        ...state,
        requiresUpdate: true
      };
    }

    default:
      return state;
  }
}
